<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { NavItem } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";

  export let label: string;
  export let navItem: NavItem | false = false;

  const dispatch = createEventDispatcher();
  function onClick(event: Event) {
    dispatch("historySelect", navItem);
  }
</script>

<style lang="scss">
  .nav-back-link {
    background: none;
    border: none;
    display: flex;
    background-color: $background;
    align-items: center;
    padding: 0 0.5em 0 0;
    margin: 0;
  }
</style>

<button type="button" class="nav-back-link" on:click={onClick}>
  <Icon icon="chevron_left" color="var(--on-surface)" />
  <Typography component="span" variant="button1" theme="on-surface">
    {label}
  </Typography>
</button>
